

import { Observable } from 'rxjs';
import { Parameter } from '../../../../@core/interfaces/common/parameter';


export interface GeneralPackageParameter extends Parameter {
  SearchTerm: number;
  OrderBy: string;
}

export abstract class GeneralPackageModuleData {
  abstract list(url: string): Observable<any[]>;
  abstract searchList(url: string,data:any): Observable<any>;
  abstract create(url: string,data: any): Observable<any>;
  abstract update(url: string,data: any): Observable<any>;
  abstract getById(url: string,data?: any): Observable<any>;
  abstract delete(url: string): Observable<any>;
}

